export enum TourCatalogPermissions {
  ALL = "Travel:TourCatalog:*",
  READ = "Travel:TourCatalog:Read",
}

export function hasTourCatalogAccess(userPermissions: string[]): boolean {
  const permissions = [TourCatalogPermissions.READ.toString(), TourCatalogPermissions.ALL.toString(), "*"];
  return userPermissions.some((permission) => permissions.includes(permission));
}
